import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Header as HeaderRS,
  Content,
  Footer,
  Sidebar as Side,
} from "rsuite";
import {
  Grid,
  Header,
  Image,
  Segment,
  Divider,
  List,
  Loader,
} from "semantic-ui-react";

import { api } from "../../../services/api";
import { formatDate, formatPrice } from "../../../utils";

import Navbarr from "../../../components/Navbar";

import "./styles.css";

export default function VisitView({ sidebar: Sidebar, ...props }) {
  const history = useHistory();
  const { visit } = props["location"]["state"];
  if (!props["location"]["state"]) {
    history.goBack();
  }
  const [visitStates, setVisitStates] = useState({
    visit: JSON.parse(visit),
    imgs: [],
    isLoadingImgs: JSON.parse(visit)["ckeckout"] ? [true, true] : [true],
    imgsExtra: [],
    isLoadingExtra: JSON.parse(visit)["pontosExtra"]
      ? new Array(JSON.parse(visit)["pontosExtra"]["imagensExtra"].length).fill(
          true
        )
      : [],
    isLoadingData: false,
  });

  useEffect(() => {
    async function fetchExtraImg(id, imgId) {
      try {
        const imgExtraAux = await api.getExtraImg(id, imgId);
        const imgBuffer = Buffer.from(imgExtraAux, "base64");
        if (imgBuffer.length !== 0) {
          const base64data = btoa(
            imgBuffer.reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, "")
          );

          setVisitStates((prevState) => ({
            ...prevState,
            imgsExtra: [
              ...prevState["imgsExtra"],
              {
                id: prevState["visit"]["pontosExtra"]["imagensExtra"][
                  imgId - 1
                ]["id"],
                anotacao: prevState["visit"]["pontosExtra"]["imagensExtra"][
                  imgId - 1
                ]["anotacao"]
                  ? prevState["visit"]["pontosExtra"]["imagensExtra"][
                      imgId - 1
                    ]["anotacao"]
                  : "Sem anotações",
                data: prevState["visit"]["pontosExtra"]["imagensExtra"][
                  imgId - 1
                ]["date"],
                img: "data:image/jpeg;base64," + base64data,
              },
            ],
          }));
        }
      } catch (err) {
        console.error("Falha ao obter imagem extra: ", err);
      } finally {
        const isLoadingExtraAux = visitStates["isLoadingExtra"];
        isLoadingExtraAux[imgId - 1] = false;
        setVisitStates((prevState) => ({
          ...prevState,
          isLoadingExtra: isLoadingExtraAux,
        }));
      }
    }

    async function fetchCheckinImg() {
      try {
        const imgCheckinAux = await api.getCheckinImg(
          visitStates["visit"]["id"]
        );
        const imgBuffer = Buffer.from(imgCheckinAux, "base64");
        if (imgBuffer.length !== 0) {
          const base64data = btoa(
            imgBuffer.reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, "")
          );

          setVisitStates((prevState) => ({
            ...prevState,
            imgs: [
              {
                nome: "checkin",
                data: prevState["visit"]["checkinDate"],
                img: "data:image/jpeg;base64," + base64data,
              },
              ...prevState["imgs"],
            ],
          }));
        }
      } catch (err) {
        console.error("Falha ao obter imagem de checkin: ", err);
      } finally {
        const isLoadingImgsAux = visitStates["isLoadingImgs"];
        isLoadingImgsAux[0] = false;
        setVisitStates((prevState) => ({
          ...prevState,
          isLoadingImgs: isLoadingImgsAux,
        }));
      }
    }

    async function fetchCheckoutImg() {
      try {
        const imgCheckoutAux = await api.getCheckoutImg(
          visitStates["visit"]["id"]
        );
        const imgBuffer = Buffer.from(imgCheckoutAux, "base64");
        if (imgBuffer.length !== 0) {
          const base64data = btoa(
            imgBuffer.reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, "")
          );

          setVisitStates((prevState) => ({
            ...prevState,
            imgs: [
              ...prevState["imgs"],
              {
                nome: "checkout",
                data: prevState["visit"]["checkoutDate"],
                img: "data:image/jpeg;base64," + base64data,
              },
            ],
          }));
        }
      } catch (err) {
        console.error("Falha ao obter imagem de checkout: ", err);
      } finally {
        const isLoadingImgsAux = visitStates["isLoadingImgs"];
        isLoadingImgsAux[1] = false;
        setVisitStates((prevState) => ({
          ...prevState,
          isLoadingImgs: isLoadingImgsAux,
        }));
      }
    }
    fetchCheckinImg();
    fetchCheckoutImg();
    if (visitStates["visit"]["pontosExtra"]) {
      for (
        let i = 0;
        i < visitStates["visit"]["pontosExtra"]["imagensExtra"].length;
        i++
      ) {
        fetchExtraImg(visitStates["visit"]["id"], i + 1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Side style={{ flex: "0 0 auto", width: "auto" }}>
        <Sidebar page={"visitlist"}></Sidebar>
      </Side>
      <Container>
        <HeaderRS>
          <Navbarr></Navbarr>
        </HeaderRS>
        <Content style={{ backgroundColor: "#FAFAFA", padding: "5px" }}>
          <Segment loading={visitStates["isLoadingData"]}>
            <Header as="h3" floated="left">
              Informações da Visita
            </Header>

            <Divider clearing />
            <Grid columns="equal" centered>
              <Grid.Row>
                <Grid.Column>
                  <Header
                    as="h4"
                    content="Promotor"
                    subheader={visitStates["visit"]["creator"]["nome"]}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Header
                    as="h4"
                    content="Loja"
                    subheader={visitStates["visit"]["loja"]["nome"]}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Header
                    as="h4"
                    content="Checkin"
                    subheader={visitStates["visit"]["checkin"]["date"]}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Header
                    as="h4"
                    content="Checkout"
                    subheader={visitStates["visit"]["checkout"] ? visitStates["visit"]["checkout"]["date"] : "Checkout não realizado"}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Header
                    as="h4"
                    content="Anotações da Visita"
                    subheader={
                      visitStates["visit"]["anotacao"]
                        ? visitStates["visit"]["anotacao"]
                        : "Sem anotações"
                    }
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Header as="h4" content="Produtos" dividing />
                  <List relaxed style={{ marginTop: "30px" }}>
                    {visitStates["visit"]["info"] &&
                      visitStates["visit"]["info"]["infoProprios"].map((pp) => {
                        return (
                          <List.Item key={pp["id"]}>
                            <List.Content>
                              <List.Header
                                style={{
                                  fontSize: "13px",
                                }}
                              >
                                {pp["produto"]["nome"]}
                              </List.Header>
                              <List.Description
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                {/*Identificador: {pp['produto']['id']} -*/}
                                Estoque: {pp["estoque"]} - Preço:{" "}
                                {formatPrice(pp["preco"].toString())}
                              </List.Description>
                            </List.Content>
                          </List.Item>
                        );
                      })}
                  </List>
                </Grid.Column>
                {visitStates["visit"]["info"] &&
                  visitStates["visit"]["info"]["infoCompetidores"].length !==
                    0 && (
                    <Grid.Column>
                      <Header as="h4" content="Competidores" dividing />
                      <List relaxed style={{ marginTop: "30px" }}>
                        {visitStates["visit"]["info"]["infoCompetidores"].map(
                          (cp) => {
                            return (
                              <List.Item key={cp["id"]}>
                                <List.Content>
                                  <List.Header
                                    style={{
                                      fontSize: "13px",
                                    }}
                                  >
                                    {cp["produto"]["nome"]}
                                  </List.Header>
                                  <List.Description
                                    style={{
                                      fontSize: "12px",
                                    }}
                                  >
                                    {/*Identificador: {cp['produto']['id']} -*/}
                                    Preço: {formatPrice(cp["preco"].toString())}
                                  </List.Description>
                                </List.Content>
                              </List.Item>
                            );
                          }
                        )}
                      </List>
                    </Grid.Column>
                  )}
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Header as="h4" dividing>
                    Imagens de Check
                    {visitStates["isLoadingImgs"].find((e) => e !== false) !==
                      undefined && (
                      <Loader
                        style={{
                          marginLeft: "5px",
                          marginBottom: "3px",
                        }}
                        active
                        inline
                        size="tiny"
                      />
                    )}
                  </Header>
                  {visitStates["imgs"].length > 0 ? (
                    <List divided relaxed horizontal>
                      {visitStates["imgs"].map((img, index) => {
                        return (
                          <List.Item key={index}>
                            <Image size="small" src={img["img"]} />
                            <List.Content>
                              <List.Header>{img["nome"]}</List.Header>
                              <List.Description
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                {img["data"]}
                              </List.Description>
                            </List.Content>
                          </List.Item>
                        );
                      })}
                    </List>
                  ) : (
                    visitStates["isLoadingImgs"].find((e) => e !== false) ===
                      undefined && (
                      <List.Description style={{ fontSize: "12px" }}>
                        Nenhuma imagem registrada
                      </List.Description>
                    )
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Header as="h4" dividing>
                    Imagens de Ponto Extra
                    {visitStates["isLoadingExtra"].find((e) => e !== false) !==
                      undefined && (
                      <Loader
                        style={{
                          marginLeft: "5px",
                          marginBottom: "3px",
                        }}
                        active
                        inline
                        size="tiny"
                      />
                    )}
                  </Header>
                  <List divided relaxed horizontal>
                    {visitStates["imgsExtra"].map((img) => {
                      return (
                        <List.Item key={img["id"]}>
                          <Image size="small" src={img["img"]} />
                          <List.Content>
                            <List.Header>
                              Identificador: {img["id"]}
                            </List.Header>
                            <List.Description
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              {formatDate(img["data"])}
                            </List.Description>
                            <List.Description
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              {img["anotacao"]}
                            </List.Description>
                          </List.Content>
                        </List.Item>
                      );
                    })}
                    {!visitStates["visit"]["pontosExtra"] && (
                      <List.Content>
                        <List.Description style={{ fontSize: "12px" }}>
                          Nenhum ponto extra registrado.
                        </List.Description>
                      </List.Content>
                    )}
                  </List>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </Content>
        <Footer></Footer>
      </Container>
    </Container>
  );
}
